import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';

export default class ButtonInputReleasedNode extends BaseNode {
    constructor() {
        super();
        this.name = 'On Button Released';
        this.id = 'node_button_input_released';
        this.icon = 'GiClick';
        this.linkedFeature = 'general';
        this.requirements = ['button'];

        const settings: Setting[] = [
            {
                id: 'BUTTON',
                name: 'Button',
                settingType: SettingType.OPTION,
                refId: 'button',
                required: true,
                default: '',
                options: [],
            },
        ];

        this.outputs = [
            {
                name: 'Released',
                portId: 'on_button_released',
                params: [],
            },
        ];

        this.settings = this.settings.concat(settings);
    }

    getCodeBlocks(): CodeBlock[] {
        const blocks: CodeBlock[] = [];
        const project: ProjectConfiguration = this.project;

        const BUTTON = this.getSettingValue('BUTTON');
        const buttonFeature = project.getFeature(BUTTON);
        if (!buttonFeature) {
            return [];
        }

        const buttonName = buttonFeature.getSettingValue('NAME');

        const links = project.getNodeLinks(this, 'on_button_released');
        if (links.length > 0) {
            const link = links[0];
            blocks.push({
                location: `button_${buttonName}_released`,
                blockType: BlockType.CODE,
                id: `node_${link.getSourceId()}`,
                template: `${project.getCodeLocationStart()}${link.getSourceId()}${project.getCodeLocationEnd()}`,
            });
        }

        return blocks;
    }

    getDetails(): string {
        return `
This block is triggered when a button input is released (or the button input line is deactivated).`;
    }
}
